var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.34277 0.234244C8.65515 -0.078128 9.16218 -0.078035 9.47461 0.234244L14.5654 5.32604C14.8778 5.63846 14.8778 6.14448 14.5654 6.4569L9.47461 11.5487C9.16218 11.861 8.65515 11.8611 8.34277 11.5487C8.0304 11.2363 8.03049 10.7293 8.34277 10.4169L12.0684 6.69128L0 6.69128L0 5.09167L12.0684 5.09167L8.34277 1.36608C8.03049 1.05365 8.0304 0.546617 8.34277 0.234244Z","fill":"#E23E52"}));
}

Arrow.defaultProps = {"width":"15","height":"12","viewBox":"0 0 15 12","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
